export default __webpack_public_path__ + "static/media/dadosProfissionais.9d3dc65d.png";